var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.navigationItem.subItems || !_vm.navigationItem.subItems.length)?_c('navigation-item-single',{staticClass:"navigation-item",attrs:{"navigation-item":_vm.navigationItem}}):_c('navigation-item-group',{staticClass:"navigation-item",attrs:{"navigation-item":_vm.navigationItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }